import React from "react";

interface CriterionFooterProps {
	clearLabel: string | null;
	guideline?: string;
	onClearInput: React.ReactEventHandler<HTMLButtonElement>;
	onSaveInput: React.ReactEventHandler<HTMLButtonElement>;
}

export default function CriterionFooter({
	clearLabel = "Clear all",
	guideline,
	onClearInput,
	onSaveInput,
}: CriterionFooterProps) {
	return (
		<footer className="flex justify-space-between">
			{guideline && <span className="range__guideline">{guideline}</span>}
			{clearLabel && (
				<button
					type="button"
					className="btn btn--link"
					onClick={onClearInput}
				>
					{clearLabel}
				</button>
			)}
			<button
				type="button"
				className="btn btn--primary btn--small"
				onClick={onSaveInput}
			>
				Save
			</button>
		</footer>
	);
}
